// barrating
(function() {

	$('.barrating__select').barrating({
        // theme: 'css-stars'
    });

})();



// WEBPACK FOOTER //
// G:/RABOTA/satpharma/dev/source/modules/barrating/barrating.js